import { signaturePadComponent } from './signaturePad.component';
import { SignaturePadService } from './signaturePad.service';
import { PollingService } from './signaturePad.polling.service';
import { CropService } from './signaturePad.crop.service';

// import { MyWebSocket } from './sig.websocket';
import SignaturePad from 'signature_pad';
import qrcode from 'qrcode-generator';
import ngQrcode from 'angular-qrcode';

window.qrcode = qrcode;

export default angular
  .module('ng1-signature-pad', [ngQrcode])
  .constant('SignaturePad', SignaturePad)
  .component('signaturePad', signaturePadComponent)
  .service('signaturePadService', SignaturePadService)
  .service('pollingService', PollingService)
  .service('cropService', CropService)

  // .factory('myWebSocket', MyWebSocket)
  .name;
